/**
 * Password Policy Utilities
 *
 * Mirrors the server-side PasswordPolicy (≥12 chars, ≥1 uppercase, ≥1 digit).
 * Shared between the signup and reset-password Stimulus controllers so the
 * client-side rules and labels stay in sync with a single source.
 */

export const MIN_LENGTH = 12;

export const RULE_LABELS = {
  too_short: "12 caractères minimum.",
  missing_uppercase: "Au moins une majuscule.",
  missing_digit: "Au moins un chiffre.",
};

export function validatePassword(pwd) {
  const v = [];
  if (pwd.length < MIN_LENGTH) v.push("too_short");
  if (!/[A-Z]/.test(pwd)) v.push("missing_uppercase");
  if (!/[0-9]/.test(pwd)) v.push("missing_digit");
  return v;
}

export function formatViolations(violations) {
  return violations.map((c) => RULE_LABELS[c] || c).join(" ");
}

export function checkRules(pwd) {
  return {
    too_short: pwd.length >= MIN_LENGTH,
    missing_uppercase: /[A-Z]/.test(pwd),
    missing_digit: /[0-9]/.test(pwd),
  };
}
